export default __webpack_public_path__ + "madfit-screen-sixth.dfcdb45b.png";